import $ from 'jquery';
import '../lib/hpanel';

/**
 * Horizontal marquees: the two footer panels and the news panel
 * (partial/_footer, partial/_slidernew) plus the in-page pair of the
 * properties index.
 */
export function initMarqueePanels() {
    if ($('#panel-left-inpage').length) {
        $('#panel-left-inpage').hpanel({
            duration: 100000,
        });
    }

    if ($('#panel-right-inpage').length) {
        $('#panel-right-inpage').hpanel({
            duration: 100000,
            direction: 'right',
        });
    }

    $('#panel-left').hpanel({
        duration: 150000,
    });

    $('#panel-right').hpanel({
        duration: 150000,
        direction: 'right',
    });

    $('#panel-news').hpanel({
        duration: 150000,
        direction: 'right',
    });
}
